import CookieConsentBanner from "./CookieConsentBanner";
import { Button } from "../ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "../ui/dialog";
import { Switch } from "../ui/switch";
import type { CookieConsent as CookieConsentState } from "@/lib/cookie-consent";

type CookieConsentProps = {
	consentReady: boolean;
	cookieConsent: CookieConsentState | null;
	cookieSettingsOpen: boolean;
	pendingAnalyticsEnabled: boolean;
	onOpenCookieSettings: (open: boolean) => void;
	onPendingAnalyticsEnabledChange: (enabled: boolean) => void;
	onAccept: () => void;
	onReject: () => void;
	onCancelSettings: () => void;
	onConfirmSettings: () => void;
};

export default function CookieConsent({
	consentReady,
	cookieConsent,
	cookieSettingsOpen,
	pendingAnalyticsEnabled,
	onOpenCookieSettings,
	onPendingAnalyticsEnabledChange,
	onAccept,
	onReject,
	onCancelSettings,
	onConfirmSettings,
}: CookieConsentProps) {
	return (
		<>
			{consentReady && cookieConsent === null ? (
				<CookieConsentBanner
					onAccept={onAccept}
					onReject={onReject}
				/>
			) : null}
			<Dialog open={cookieSettingsOpen} onOpenChange={onOpenCookieSettings}>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>Cookie settings</DialogTitle>
						<DialogDescription>
							We use cookies to measure how people use Text Formatter and improve performance,
							content, and user experience. Analytics cookies help us understand which pages are most
							useful.
						</DialogDescription>
					</DialogHeader>
					<div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-4">
						<div className="flex items-center justify-between gap-4">
							<div>
								<p className="text-sm font-semibold text-slate-900">Analytics cookies</p>
								<p className="mt-1 text-sm text-slate-600">
									Allow anonymous usage measurement to improve content and performance.
								</p>
							</div>
							<Switch
								id="analytics-cookies-switch"
								checked={pendingAnalyticsEnabled}
								onCheckedChange={onPendingAnalyticsEnabledChange}
							/>
						</div>
					</div>
					<DialogFooter className="justify-start sm:justify-end">
						<Button type="button" variant="outline" onClick={onCancelSettings}>
							Cancel
						</Button>
						<Button type="button" onClick={onConfirmSettings}>
							Confirm
						</Button>
					</DialogFooter>
				</DialogContent>
			</Dialog>
		</>
	);
}
